import loadable from "@loadable/component";
import { ErrorBoundary } from "../../../components";
import FullPageLoader from "@Components/FullPageLoader";

const ProfileReferralProgram = loadable(() => import("./ProfileReferDesktop"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <ProfileReferralProgram {...props} />
  </ErrorBoundary>
);
